module.exports = __webpack_public_path__ + "img/arrow.3626b3a8.svg";